import { BlankState, Box } from '@domain-group/suit-theme'

import BlankStateImageUrl from './assets/Accounting.svg'

interface OrderReconciliationBlankStateProps {
  paragraph: string,
}

const OrderReconciliationBlankState = (props: OrderReconciliationBlankStateProps) => {
  const { paragraph } = props

  return (
    <BlankState
      boxProps={{ border: '1px solid', marginBottom: ['large', 0] }}
      imageUrl={BlankStateImageUrl}
      sidebar
    >
      <Box
        alignItems="center"
        flexDirection="column"
        marginBottom="large"
        paddingBottom="large"
        paddingX="xlarge"
        textAlign="center"
      >
        {/*
         // @ts-expect-error TS2339 */}
        <BlankState.Title>No Orders to Reconcile</BlankState.Title>

        {/*
         // @ts-expect-error TS2339 */}
        <BlankState.Paragraph>
          {paragraph}
          {/*
         // @ts-expect-error TS2339 */}
        </BlankState.Paragraph>
      </Box>
    </BlankState>
  )
}

export default OrderReconciliationBlankState
